var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section", attrs: { id: "tobe" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "section-body" }, [
      _c(
        "div",
        {
          staticClass: "btn bg-pink",
          class: {
            "bg-pink": _vm.to_be !== "professional",
            "bg-gray": _vm.to_be === "professional"
          },
          on: {
            click: function($event) {
              _vm.setToBe("schedule")
              _vm.$emit("scrollTo", "#PerSchedule")
            }
          }
        },
        [_vm._v("em um dia específico")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn",
          class: {
            "bg-pink": _vm.to_be !== "schedule",
            "bg-gray": _vm.to_be === "schedule"
          },
          on: {
            click: function($event) {
              _vm.setToBe("professional")
              _vm.$emit("scrollTo", "#PerProfessional")
            }
          }
        },
        [_vm._v("com um profissional favorito")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _vm._v("VOCÊ DESEJA QUE A LIMPEZA SEJA\n    "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f10c25c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f10c25c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/OrdersAndSubscriptions/ToBe.vue
// module id = null
// module chunks = 